import Model, { ID, IsoDate, IsoDateTime, MODEL_LEVEL } from 'src/models/model'
import OrderItem from 'src/models/order-item/OrderItem'
import Payment from 'src/models/payment/Payment'
import TransferPayout from 'src/models/transfer/TransferPayout'

export const DATE_POSITIONS = {
  PREFIX: 'prefix',
  SUFFIX: 'suffix',
  NONE: 'none'
}
DATE_POSITIONS.ALL = _.values(DATE_POSITIONS)

export const DAY_CUTOFF_HOUR_OFFSET = 4

export default class Transfer extends Model {
  static name = 'Transfer'

  static versioned = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Financial]

  static define () {
    this.fields = {
      id: {
        type: ID,
        sortable: true
      },

      date: {
        type: IsoDate,
        sortable: true,
        output: true
      },

      transferInitiationDate: {
        type: IsoDate,
        sortable: true,
        output: true
      },

      cashPaymentCount: {
        type: Number,
        output: true
      },
      cashPaymentTotal: {
        type: Number,
        output: true
      },

      creditCardPaymentCount: {
        type: Number,
        output: true
      },
      creditCardPaymentTotal: {
        type: Number,
        output: true
      },

      externalTicketingPaymentCount: {
        type: Number,
        output: true
      },
      externalTicketingPaymentTotal: {
        type: Number,
        output: true
      },
      priorDayUnclaimedExternalTicketingRefundTotal: {
        type: Number,
        output: true
      },

      unclaimedExternalTicketingRefundTotal: {
        type: Number,
        output: true
      },

      cashRefundCount: {
        type: Number,
        output: true
      },
      cashRefundTotal: {
        type: Number,
        output: true
      },

      creditCardRefundCount: {
        type: Number,
        output: true
      },
      creditCardRefundTotal: {
        type: Number,
        output: true
      },

      externalTicketingRefundCount: {
        type: Number,
        output: true
      },
      externalTicketingRefundTotal: {
        type: Number,
        output: true
      },

      lostDisputesCount: {
        type: Number,
        output: true
      },
      lostDisputesTotal: {
        type: Number,
        output: true
      },
      lostDisputesFee: {
        type: Number,
        output: true
      },

      totalNetCount: {
        type: Number,
        output: true
      },
      totalNet: {
        type: Number,
        output: true
      },

      stripeFee: {
        type: Number,
        output: true
      },
      hasStripeTax: {
        type: Boolean,
        output: true
      },
      stripeFeeTax: {
        type: Number,
        output: true
      },
      stripeFeeNet: {
        type: Number,
        output: true
      },
      indyFeeCapSavings: {
        type: Number,
        output: true
      },
      indyFixedDailyFee: {
        type: Number,
        output: true
      },
      indyFixedServicesDailyFee: {
        type: Number,
        output: true
      },
      indyFee: {
        type: Number,
        output: true
      },
      priorDayIndyBalance: {
        type: Number,
        output: true
      },
      indyTransfer: {
        type: Number,
        output: true
      },
      priorDayBalance: {
        type: Number,
        output: true
      },
      totalSitePayout: {
        type: Number,
        output: true
      },
      indySiteSalesPayout: {
        type: Number,
        output: true
      },
      externalSiteTicketingPayout: {
        type: Number,
        output: true
      },
      circuitTransferId: {
        type: String,
        output: true
      },
      transferPayouts: {
        type: [TransferPayout],
        reference: true,
        output: true
      },
      transferError: {
        type: String,
        output: true
      },

      notes: {
        type: String,
        default: null
      },

      computedAt: {
        type: IsoDateTime,
        default: null,
        output: true
      },
      transferedAt: {
        type: IsoDateTime,
        default: null,
        output: true
      },
      firstSitePayoutArrivalDate: {
        type: IsoDate,
        default: null,
        output: true
      },

      state: {
        type: String,
        output: true
      },

      payments: {
        type: [Payment],
        reference: true,
        output: true
      },
      orderItems: {
        type: [OrderItem],
        reference: true,
        output: true
      },
      voidedOrderItems: {
        type: [OrderItem],
        reference: true,
        output: true
      },

      action: {
        type: String,
        input: true,
        default: null
      }
    }

    this.paginate = true

    this.computed = {
      indyTransferTotal () {
        return this.indyTransfer + this.indyFixedServicesDailyFee
      }
    }
  }

  async computeTransferData () {
    this.action = 'compute_transfer_data'

    try {
      await this.save()
    } catch (error) {
      console.log(error)
      return { error }
    } finally {
      this.resetField('action')
    }
  }

  async executeTransfer () {
    this.action = 'execute_transfer'

    try {
      await this.save()
    } catch (error) {
      console.log(error)
      return { error }
    } finally {
      this.resetField('action')
    }
  }
}
